// Module
var code = "<react-component name=\"ContactAttendancesReport\"></react-component>\n";
// Exports
module.exports = code;